import React, { useEffect, useState } from 'react';

import { ReactComponent as CardBackground } from '../../images/backgrounds/gradient-card.svg';
import HeadingCtas from '../Generic/HeadingCtas';
import PageSection from '../PageSections/PageSection';
import ContentfulImage from './ContentfulImage';
import RichTextConverter from './RichText/RichTextConverter';
import * as styles from './Tabs.module.scss';

const formatTabId = (tabId) => tabId.replace(/\s+/g, '-').replace(/&/g, 'and').toLowerCase();

const TabbedSection = ({ section, activeTab }) => {
  const tabId = formatTabId(section.subtitle);

  return (
    <div
      id={tabId}
      className={[styles.tab, activeTab === tabId ? styles.active : ''].join(' ')}
      data-analytics-component={'tab'}
      data-analytics-id={section.title}
    >
      <span className={styles.eyebrow}>{section.subtitle}</span>
      <h2>{section.title}</h2>
      <RichTextConverter className={styles.content} copy={section.copy} />
      <div className={styles.callout}>
        <CardBackground className={styles.background} />
        <div className={styles.center}>
          <ContentfulImage className={styles.icon} imageFragment={section.contentSection.image} lazy={true} />
          <p>{section.contentSection.title}</p>
        </div>
      </div>
    </div>
  );
};

export default function Tabs({ section }) {
  const tabbedSections = section.content.filter((entry) => entry.__typename === 'ContentfulSectionContentSection');
  const stickyFooterCta = section.content.filter((entry) => entry.__typename === 'ContentfulEmbedLink');

  const [activeTab, setActiveTab] = useState(tabbedSections.length > 0 ? formatTabId(tabbedSections[0].subtitle) : '');

  // If the URL has a hash, set the active tab to that hash
  useEffect(() => {
    if (window.location.hash) {
      setActiveTab(window.location.hash.replace('#', ''));
    }
  }, []);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <>
      <div className={styles.navWrapper}>
        <div className={styles.tabButtons} style={{ gridTemplateColumns: `repeat(${tabbedSections.length}, 1fr)` }}>
          {tabbedSections.map((tab, i) => (
            <button
              className={[styles.tabButton, activeTab === formatTabId(tab.subtitle) ? styles.active : ''].join(' ')}
              key={i}
              onClick={() => handleTabClick(formatTabId(tab.subtitle))}
              data-analytics-component={'tab-button'}
              data-analytics-id={tab.subtitle}
            >
              {tab.subtitle}
            </button>
          ))}
        </div>
      </div>

      <PageSection slim className={styles.tabs} data-analytics-section={'tabbed-sections'}>
        {tabbedSections.map((tab, i) => (
          <TabbedSection key={i} section={tab} activeTab={activeTab} />
        ))}
      </PageSection>

      <div data-analytics-component={'footer-cta'} data-analytics-id={section.ctaLabel} className={styles.footerCta}>
        <div className={styles.cta}>
          <h2>{section.ctaLabel}</h2>
          <HeadingCtas ctas={stickyFooterCta} className={styles.ctaButton} />
          <ContentfulImage className={styles.ctaImage} imageFragment={section.mainImage} lazy={true} />
        </div>
      </div>
    </>
  );
}
